module.exports = __webpack_public_path__ + "media/images/plane-b17359c01fbb4d2c9a812a8587960d97.jpg";